module.exports = __webpack_public_path__ + "static/media/logo_full.09e5ad83.png";